import { InfoCircleFilled, WarningFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { colorFormat } from "utils/format/ColorFormat";
import { strings } from "utils/localizedStrings";
import { IModalConfirmation } from "./model/ModalConfirmationModel";

const ModalConfirmationComponent = (props: IModalConfirmation) => {
  const {
    cancelText,
    okText,
    loading,
    isDanger = false,
    title,
    width,
    onOk,
    onCancel,
  } = props?.data;

  return Modal.confirm({
    content: title || strings.GlobalMessage.DeleteConfirmation,
    okText: okText || strings.GlobalLabels.Confirmed,
    okType: "primary",
    width,
    okButtonProps: {
      danger: isDanger,
      loading: loading,
    },
    icon: isDanger ? (
      <WarningFilled style={{ color: colorFormat?.Red_Dark }} />
    ) : (
      <InfoCircleFilled style={{ color: colorFormat?.Blue }} />
    ),
    centered: true,
    cancelText: cancelText || strings.GlobalLabels.Cancel,
    onCancel: onCancel,
    async onOk() {
      await onOk();
    },
  });
};

export default ModalConfirmationComponent;
